import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NgbDate, NgbDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BookingService } from '../../../../core/services/booking.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { DELEGATE_CTOR } from '@angular/core/src/reflection/reflection_capabilities';
declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
  selector: 'app-select-plant',
  templateUrl: './select-plant.component.html',
  styleUrls: ['./select-plant.component.scss']
})
export class SelectPlantComponent implements OnInit, AfterViewInit {
  dateModel: NgbDateStruct;
  @ViewChild('dp') datepicker: NgbDatepicker;
  
  public plant: string;
  public address: string;
  public date: string = 'Fecha sin seleccionar';
  public hour: string = 'Hora sin seleccionar';
  public availableHours: any = []; // Contains the available hours to book in a plant
  public minHour: string;
  public dateNoFormat: string;
  public hourNoFormat: string;
  public btnplant = 1;
  public isClicked = [];
  public myVar = false;
  public reference = '';
  public arrows: any;
  public codePlant: string;
  public latitude: string;
  public longitude: string;
  public emptyHours: boolean = false; // Control whether to show or not a "no available hours" message to the user
  public startDate: NgbDateStruct;
  /* Ngb-datepicker properties */
  outsideDays;
  minimumDate;
  maximumDate;
  disabledDays;

  constructor(
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private bookingService: BookingService,
    private toastr: ToastrService
  ) { }
  ngAfterViewInit(): void {
    this.ngxLoader.startLoader('selectType-loader');
  }

  ngOnInit() {
    this.setCalendarConfig();
    this.getSelectedPlant();

  }
  public getAvailabilityinNextMonth(month, year) {
    var init_date = `${month}-01-${year}`;
    var end_date = `${month}-31-${year}`;
    var daysInMonth = new Date(year, month, 0).getDate();
    this.bookingService.getAvailabilityByPlantAndMonth(init_date, end_date, this.plant).subscribe((response) => {
      
      if (response.message && response.status) {
        this.maximumDate = { year: year, month: month, day: daysInMonth };
      }
    });
  }
  public getCalendarAvailability(event, includeNextMonth = false) {
    const month = event.month;
    const year = event.year;
    const lastDateInMonth = new Date(year, month, 0);
    const systemDate = new Date();
    // const actualDate = new Date(year, month, 0);
    this.bookingService.getCalendarAvailability(month, year, this.plant).subscribe((response) => {
      if (response.message && response.status) {
        this.disabledDays = (date: NgbDate) => {
          const d = new Date(date.year, date.month - 1, date.day);
          return !(response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== null && response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== undefined);
        };
        if (response.message.length > 0) {
          let firstAvailabilityDay = new Date(response.message[0].day.replace(/-/g, '\/'));
          this.dateModel = { year: year, month: month, day: firstAvailabilityDay.getDate() };
          this.onDateSelect(this.dateModel);
          if(includeNextMonth)
            this.datepicker.navigateTo(this.dateModel);
        }
        else {
          if (lastDateInMonth.getDate() == systemDate.getDate() && !includeNextMonth) {
            includeNextMonth = true;
            event.month += 1;
            if (event.month > 12) {
              event.month = 1;
              event.year += 1;
            }
            return this.getCalendarAvailability(event, includeNextMonth);
          }
          else {
            this.toastr.error("Agenda No disponible");
            this.availableHours = [];
          }
        }
      }
      this.ngxLoader.stop();
    });
  }

  /* This sets the initial calendar configuration > No sundays and min/max date range */
  public setCalendarConfig() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const lastDate = new Date(year, month, 0);
    this.minimumDate = { year, month, day }; // Minimum available date
    this.maximumDate = { year: year, month: month, day: lastDate.getDate() }; // Maximum available date
    this.outsideDays = 'hidden';

    // sundays are disabled
    this.disabledDays = (date: NgbDate) => {
      const d = new Date(date.year, date.month - 1, date.day);
      return d.getDay() === 0;
    };
  }

  /* Get the information of the previously selected plant */
  public getSelectedPlant() {
    this.bookingService.getDataPlantAdressSelected().subscribe(
      (response) => {
        this.plant = response.plant;
        this.address = response.address;
        this.reference = response.reference;
        this.codePlant = response.codePlant;
        this.latitude = response.latitude;
        this.longitude = response.longitude;
        if (this.plant === undefined) {
          this.route.navigateByUrl('/');
        }
      }
    );
  }
  setDayNoWorking(event) {
    let nonWorkingDays: any = { // Contains the 1st response needed to execute a 2nd service
      status: false,
      message: {
        days: [],
        _id: '',
        date: '',
        __v: 0,
        createdAt: '',
        updatedAt: ''
      }
    };
    const dates = {
      year: event.year ? event.year : new Date().getFullYear(),
      month: event.month ? event.month : new Date().getMonth() + 1 // Plus 1 to send the month to the service
    }; // This object helps to avoid errors after change when ngxLoader starts after modal has been displayed
    this.bookingService.getNotWorked(dates.year, dates.month).toPromise().then(
      (res) => {

        /* If the response has a null message, this sets days as a void array to push sundays to it */
        if (res.status === true) {
          if (res.message !== null) {
            nonWorkingDays = res;
          } else {
            nonWorkingDays.message.days = [];
          }
          this.isDisabled(nonWorkingDays, dates.year, dates.month);
        }
      },
      (err) => {
        this.ngxLoader.stopLoader('selectType-loader');
      }
    );
  }
  /* Disables holydays and looks for availability of booking for rfest of the days */
  pickUpDate(event) {
    this.ngxLoader.start();
    var month = event.month + 1;
    var year = event.year;
    if (month > 12) {
      month = 1;
      year += 1;
    }
    this.getAvailabilityinNextMonth(month, year);
    this.getCalendarAvailability(event);
  }

  /* Disable days based on the ms mandatory returned days */
  public isDisabled(availableDays, year, month) {
    const daysOfMonth = new Date(year, month, 0).getDate(); // This returns the total days of the month (number)
    const disabledDates: NgbDateStruct[] = [];
    /* This finds and push to the disabled days all sundays */
    for (let i = 0; daysOfMonth >= i; i++) {
      const date = new Date(year, month - 1, i);
      if (date.getDay() === 0) {
        disabledDates.push({ year, month, day: date.getDate() });
      }
    }
    /* This looks for all holydays that comes in the not-worked-days service */
    availableDays.message.days.forEach(element => {
      disabledDates.push({ year, month, day: element.day });
    });
    /* Then the disabled days are set */
    this.disabledDays = (dateStruct: NgbDateStruct) => {
      return disabledDates.find(date => new NgbDate(date.year, date.month, date.day).equals(dateStruct));
    };
  }

  /* Gets the available hours by seleted day */
  onDateSelect(event) {
    const date = event.year + '-' + event.month + '-' + event.day;
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const eventDate = moment(event.year + '-' + event.month + '-' + event.day, 'YYYY-MM-DD').format();
    const dateNow = moment(year + '-' + month + '-' + day, 'YYYY-MM-DD').format();
    this.availableHours = [];

    if (eventDate <= dateNow) {
      this.minHour = (currentDate.getHours() + 1).toString();
      let minutes = currentDate.getMinutes().toString();

      if (parseInt(minutes) <= 9) {
        minutes = '0' + minutes;
      }
      if (parseInt(this.minHour) <= 9) {
        this.minHour = '0' + this.minHour + ':' + minutes;
      } else if (parseInt(this.minHour) > 10) {
        this.minHour = this.minHour + ':' + minutes;
      }
    }

    this.bookingService.getBookingAvailabilityByPlant(date, this.plant).subscribe(response => {
      let rangeOfHours = response.message[0].rangeOfHours;
      this.sortByHour(rangeOfHours)
      const filteredHours = rangeOfHours.filter(hour => {
        return this.isVisible(response.message[0].end_date, hour.hour) && hour.reservated < hour.totalForReservation
      });

      this.availableHours = filteredHours
      this.emptyHours = this.availableHours.length

    });

    const testDate = (moment(date, 'YYYY-MM-DD').format()).split('T');
    this.date = this.convertStringToFomart(testDate[0]);
    this.dateNoFormat = testDate[0];
    this.hour = 'Hora sin seleccionar';
    this.btnplant = 1;
    this.myVar = false;
    this.isClicked = [];
  }

  /* New function time hour visible*/
  isVisible(initDate: string, backendTime: string) {
    const currentDate = moment(initDate).format("YYYY-MM-DD");
    const currentBackendDateTime = moment(currentDate + " " + backendTime);
    const currentDateTime = moment();
    const diff = currentDateTime.diff(currentBackendDateTime);
    return diff < 0;
  }

  /* Converts the interpolated date to a day/month/year format */
  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }

  /* Converts from hours to seconds */
  convertHourToSeconds(hour) {
    return (+hour.split(':')[0]) * 60 * 60 + (+hour.split(':')[1]) * 60;
  }

  /* Converts from seconds to hours */
  convertSecondsToHour(seconds, format = 'H') {
    return moment().startOf('day')
      .seconds(seconds)
      .format(format);
  }

  /*  */
  takeHour(hour) {
    this.isClicked = [];
    this.myVar = true;
    this.hour = moment(hour, ['H:mm']).format('h:mm A');
    this.hourNoFormat = hour;
    this.btnplant = 0;
  }

  /* Saves a pre-booking */
  preBooking() {
    if (this.date !== 'Fecha sin seleccionar' || this.hour !== 'Hora sin seleccionar') {

      this.ngxLoader.start();
      gtag('event', 'Reserva5', { 'event_category': 'Reserva5', 'event_label': 'Reserva5', 'value': 'Reserva5' });
      this.bookingService.savePreBooking(
        this.dateNoFormat,
        this.hourNoFormat,
        this.plant,
        this.address,
        this.reference,
        this.codePlant,
        this.latitude,
        this.longitude
      ).subscribe(
        response => {
          this.ngxLoader.stop();
          if (response.status === true) {
            this.route.navigateByUrl('/booking/personal-information');
          }
        },
        (err) => this.ngxLoader.stop()
      );
    }
  }

  /* Clean some variables */
  cancelSelect() {
    this.date = 'Fecha sin seleccionar';
    this.hour = 'Hora sin seleccionar';
    this.btnplant = 1;
    this.myVar = false;
    this.isClicked = [];
    this.availableHours = [];
    this.emptyHours = false;
  }

  /* Sort the rangeOfHours from a service by hour */
  sortByHour(rangeOfHours: Array<any>) {
    rangeOfHours.sort((a, b) => {
      const dateA = moment(a.hour, 'HH:mm');
      const dateB = moment(b.hour, 'HH:mm');
      if (dateA < dateB) {
        return -1;
      }
      if (dateA > dateB) {
        return 1;
      }
      return 0;
    });
  }
  atras() {
    gtag('event', 'Atras1', { 'event_category': 'Atras1', 'event_label': 'Atras1', 'value': 'Atras1' });
    this.route.navigate(['/booking/search-type']);
  }
}
